import { Condition } from "@op/opds.opux";
import { Modal } from "@op/opds.opux-modal";
import { useEffect, useMemo, useState } from "react";
import LoadingWrapper from "./common/loading-wrapper/LoadingWrapper";
import { useKeepAlive } from "./hooks/useKeepAlive";
import { useReferenceNumbers } from "./providers/ReferenceNumberProvider";
import ReferenceNumberCalculatorText from "./reference-number-calculator/ReferenceNumberCalculatorText";
import ReferenceNumberCalculatorButtons from "./reference-number-calculator/buttons/ReferenceNumberCalculatorButtons";
import ReferenceNumberCalculatorForm from "./reference-number-calculator/form/ReferenceNumberCalculatorForm";
import ReferenceNumberList from "./reference-number-calculator/list/ReferenceNumberList";

const openPrintDialog = (): Promise<void> => {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      window.print();
      resolve();
    }, 100);
  });
};

function App() {
  const ready = useKeepAlive();
  const { loading, error, referenceNumbers } = useReferenceNumbers();
  const [isPrinting, setIsPrinting] = useState(false);
  const originalTitle = useMemo(() => {
    return document.title;
  }, []);

  const handlePrint = async () => {
    setIsPrinting(true);
    await openPrintDialog();    
  };

  useEffect(() => {
    const beforePrint = () => {
      document.title = document.title.replaceAll(" ", "");
      setIsPrinting(true);
    };

    const afterPrint = () => {
      document.title = originalTitle;
      setIsPrinting(false);
    };

    window.addEventListener("beforeprint", beforePrint);
    window.addEventListener("afterprint", afterPrint);

    return () => {
      window.removeEventListener("beforeprint", beforePrint);
      window.removeEventListener("afterprint", afterPrint);
    };
  }, [originalTitle]);

  return (
    <div className="opux-v6__opds reference-number-calculator">
      <ReferenceNumberCalculatorText />
      <ReferenceNumberCalculatorForm />
      <LoadingWrapper isLoading={loading || !ready} error={error}>
        <Condition
          value={referenceNumbers.length > 0}
          renderIfValueEquals={true}
        >
          <ReferenceNumberCalculatorButtons print={handlePrint} />
          <ReferenceNumberList />
        </Condition>
      </LoadingWrapper>
      <Modal
        large
        testId="print-modal"
        isOpen={isPrinting}
        onUpdate={(state) => {
          setIsPrinting(state.open);
        }}
        className="opux-v6__opds reference-number-calculator"
        appElement={document.getElementById("ya-refcalc-root")!}
      >
        <ReferenceNumberList />
      </Modal>
    </div>
  );
}

export default App;
